import React from "react";

export default function RightSection() {
  return (
    <div>
      <img
        src="assets/right-image.jpg"
        style={{ width: 550, height: 500 }}
      ></img>
    </div>
  );
}
